import * as StateLib from "@/Utils/StateLib";
import React, { Fragment } from "react";
import { HorizontalToolbar, Divider } from "@theorgchartdev/storybook";
import BranchToolsComposite from "./BranchToolsComposite/BranchToolsComposite";
import BoxFormatToolsComposite from "./BoxFormatToolsComposite/BoxFormatToolsComposite";
import ChartToolsComposite from "./ChartToolsComposite/ChartToolsComposite";
import GroupingToolsComposite from "./GroupingToolsComposite/GroupingToolsComposite";
import LineToolsComposite from "./LineToolsComposite/LineToolsComposite";
import TextFormatToolsComposite from "./TextFormatToolsComposite/TextFormatToolsComposite";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { RenderToolbarContent } from "./ContextualToolbar";
import { GetToolbarStyle } from "./ContextualToolbar";
import { enumChartElement } from "@coreapp/constants";
import { editModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

const dividerClass = "ocn-toolbar-horizontal-divider";

const ContextualToolbarEditChart = () => {
  const { wsMgr } = useWSMgrContext();
  let workspaceMgr = StateLib.GetWSMgr();
  let firstSelectedBox = null;
  let firstSelectedCell = null;
  let lineSelection = null;
  let isSelectingPosition = false;
  const isPositionDocument = workspaceMgr.GetDoc().IsPositionDocument();

  if (workspaceMgr) {
    firstSelectedBox = workspaceMgr.GetFirstSelectedBox(true);
    firstSelectedCell = workspaceMgr.GetFirstSelectedElement(enumChartElement.boxCell);
    lineSelection = workspaceMgr.GetFirstSelectedElement(enumChartElement.connectingLine);
    isSelectingPosition =
      firstSelectedBox?.IsPositionBox() || firstSelectedCell?.fParentBox?.IsPositionBox();
  }

  const leftContent = (
    <Fragment>
      {firstSelectedBox && (
        <Fragment>
          <ChartToolsComposite />
          <div className={dividerClass}>
            <Divider vertical={true} />
          </div>
        </Fragment>
      )}
      {firstSelectedBox && false && (
        <Fragment>
          <GroupingToolsComposite />
          <div className={dividerClass}>
            <Divider vertical={true} />
          </div>
        </Fragment>
      )}
      {firstSelectedBox && (
        <Fragment>
          <BoxFormatToolsComposite />
          <div className={dividerClass}>
            <Divider vertical={true} />
          </div>
        </Fragment>
      )}
      {(firstSelectedBox || firstSelectedCell) && (
        <Fragment>
          <TextFormatToolsComposite
            showFieldDisplay
            dataTestIdPrefix={editModeTestId("text-format") ?? "ctx-toolbar-chart"}
          />
          <div className={dividerClass}>
            <Divider vertical={true} />
          </div>
          {firstSelectedBox && !(isPositionDocument && !isSelectingPosition) && (
            <BranchToolsComposite />
          )}
        </Fragment>
      )}
      {lineSelection && (
        <Fragment>
          {(firstSelectedBox || firstSelectedCell) && (
            <div className={dividerClass}>
              <Divider vertical={true} />
            </div>
          )}
          <LineToolsComposite />
          <div className={dividerClass}>
            <Divider vertical={true} />
          </div>
          <BranchToolsComposite />
        </Fragment>
      )}
    </Fragment>
  );

  return (
    <HorizontalToolbar
      style={GetToolbarStyle()}
      leftContent={RenderToolbarContent() ? leftContent : null}
    />
  );
};

export default ContextualToolbarEditChart;
